<template>
  <div>
    <v-row dense class="ml-2" v-if="produtos.length">
      <v-col cols="12" sm="6">
        <small>
          {{ produtos.length | pluralize(['produto selecionado', 'produtos selecionados']) }}
        </small>
      </v-col>
      <v-col cols="12" sm="6" class="text-right">
        <px-requisicao-geracao-menu :produtos="produtos"/>
      </v-col>
    </v-row>
    <px-requisicao-produto-chip v-for="requisicaoProduto in produtosVisiveis"
                                :key="requisicaoProduto.id"
                                :requisicao-produto="requisicaoProduto"
                                @remove="onRemoveItem"/>
    <px-lista-requisicao-produtos-selecionados-menu v-if="hasMenu"
                                                    :produtos="produtos"
                                                    @remove="onRemoveItem"/>
  </div>
</template>

<script>
import RequisicaoProdutoChip
  from '@/modules/requisicao/geracao/lista-selecao-requisicao-produtos/RequisicaoProdutoChip.vue';
import ListaRequisicaoProdutosSelecionadosMenu
  from '@/modules/requisicao/geracao/ListaRequisicaoProdutosSelecionadosMenu.vue';
import RequisicaoGeracaoMenu from '@/modules/requisicao/geracao/RequisicaoGeracaoMenu.vue';

const PRODUTOS_VISIVEIS = 5;

export default {
  props: {
    produtos: {
      type: Array,
    },
  },
  computed: {
    produtosVisiveis() {
      if (!this.produtos || !this.produtos.length) {
        return [];
      }
      return this.produtos.slice(0, PRODUTOS_VISIVEIS);
    },
    hasMenu() {
      return this.produtos && this.produtos.length > PRODUTOS_VISIVEIS;
    },
  },
  methods: {
    onRemoveItem(requisicaoProduto) {
      this.$emit('remove', requisicaoProduto);
    },
  },
  components: {
    pxRequisicaoProdutoChip: RequisicaoProdutoChip,
    pxListaRequisicaoProdutosSelecionadosMenu: ListaRequisicaoProdutosSelecionadosMenu,
    pxRequisicaoGeracaoMenu: RequisicaoGeracaoMenu,
  },
};
</script>
